module.exports = __webpack_public_path__ + "img/r1.5751278d.jpg";